export const downloadPages = {
  appStore: {
    image: 'images/app-store-logo.png',
    redirectUrl: 'https://itunes.apple.com/us/app/vtex-insights/id1213379743?ls=1&mt=8',
  },
  googlePlay: {
    image: 'images/google-play-logo.png',
    redirectUrl: 'https://play.google.com/store/apps/details?id=com.insightsproject&hl=pt_BR',
  },
}

export const details = {
  visualization: {
    title: 'overview.visualizationTitle',
    description: 'overview.visualizationDescription',
    image: 'images/visualization-icon.png',
  },
  speed: {
    title: 'overview.realTimeTitle',
    description: 'overview.realTimeDescription',
    image: 'images/time-icon.png',
  },
  results: {
    title: 'overview.makeMoneyTitle',
    description: 'overview.makeMoneyDescription',
    image: 'images/money-icon.png',
  },
}

export const featuresDescription = [
  {
    title: 'features.overviewTitle',
    content: 'features.overviewDescription',
    textAlignment: 'right',
  },
  {
    title: 'features.relatedMetricsTitle',
    content: 'features.relatedMetricsDescription',
    textAlignment: 'right',
  },
  {
    title: 'features.evolutionTitle',
    content: 'features.evolutionDescription',
    textAlignment: 'right',
  },
  {
    title: 'features.marketTitle',
    content: 'features.marketDescription',
    textAlignment: 'left',
  },
  {
    title: 'features.dataUpdatesTitle',
    content: 'features.dataUpdatesDescription',
    textAlignment: 'left',
  },
  {
    title: 'features.usabilityTitle',
    content: 'features.usabilityDescription',
    textAlignment: 'left',
  },
]



// WEBPACK FOOTER //
// ./src/constants.js